// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kvDIV > * {
    align-self: center;
}

.paramControl {
    border: 1px solid lightgray;
    border-radius: 4px;
    padding: 2px;
}

.restCallRadio {
    margin: 2px 0px;
}

.restPreview {
    margin-top: 4px;
}

.restTextArea {
    min-height: 120px;
}

.addressFormula {
    margin: 20px 0px 5px 0px;
}

.pathFormula {
    margin: 5px 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/workflow/modules/restCall/restCall.settings.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".kvDIV > * {\n    align-self: center;\n}\n\n.paramControl {\n    border: 1px solid lightgray;\n    border-radius: 4px;\n    padding: 2px;\n}\n\n.restCallRadio {\n    margin: 2px 0px;\n}\n\n.restPreview {\n    margin-top: 4px;\n}\n\n.restTextArea {\n    min-height: 120px;\n}\n\n.addressFormula {\n    margin: 20px 0px 5px 0px;\n}\n\n.pathFormula {\n    margin: 5px 0px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
